<template>
  <div class="AboutSlider relative">
    <flickity
      ref="flickity"
      :options="flickityOptions"
      class="shadow"
    >
      <div
        v-for="(item, index) in items"
        :key="index"
        class="w-full"
      >
        <img
          class="block"
          src="http://placehold.it/1500x500"
          alt=""
        >
      </div>
    </flickity>
    <button
      class="AboutSlider__button AboutSlider__button--prev button is-orange is-filled is-xs is-square border-none block"
      @click="$refs.flickity.previous()"
    >
      <i class="mps mps-angle-left mps-fw mps-lg"/>
    </button>
    <button
      class="AboutSlider__button AboutSlider__button--next button is-orange is-filled is-xs is-square border-none block"
      @click="$refs.flickity.next()"
    >
      <i class="mps mps-angle-right mps-fw mps-lg"/>
    </button>
  </div>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  name: 'AboutSlider',
  components: { Flickity },
  data () {
    return {
      flickityOptions: {
        imagesLoaded: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false
      },
      items: 5
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import '~utils';

.AboutSlider__button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999;
  &--next {
    right: -30px;
  }
  &--prev {
    left: -30px;
  }
}
</style>
